import { oc } from "@orpc/contract";
import { z } from "zod";
import { catalogErrors } from "./errors";
import { sitePreviewQuerySchema, sitePreviewSchema } from "./site-preview";

/**
 * The regional Site Preview API: what a website looks like before someone saves a login for it —
 * its icon and its title, fetched by the server so the browser never loads another site. Its own
 * contract and client, separate from Connections, because it is its own responsibility: it reads
 * the public web and touches no account. The server mounts it under `/api`.
 */
const route = oc.$route({ inputStructure: "detailed" });

export const sitePreviewContract = oc
  .errors(
    catalogErrors([
      "UNAUTHORIZED",
      "FORBIDDEN",
      "VALIDATION_ERROR",
      "RATE_LIMITED",
      "INTERNAL_ERROR",
      "AUTH_UNAVAILABLE",
    ]),
  )
  .tag("Site preview")
  .prefix("/workspaces/{workspaceId}/sites")
  .router({
    preview: route
      .route({ method: "GET", path: "/preview" })
      .input(
        z.object({
          params: z.object({ workspaceId: z.string().min(1) }),
          query: sitePreviewQuerySchema,
        }),
      )
      .output(sitePreviewSchema),
  });

export type SitePreviewContract = typeof sitePreviewContract;
